import React, { useRef, useEffect, useContext } from 'react';
import { useTheme } from '@mui/styles';
import PropTypes from 'prop-types';
import D3ProgdDonut from '../../d3/D3ProgDonut';

import { GroupsContext } from '../../data/groups-service';

import {
    select as D3select,
    scaleOrdinal as D3scaleOrdinal,
} from 'd3';

const DoubleDonutChart = ({
    mouseover,
    data,
    progdata,
    filter,
    size,
    onclick,
    className,
}) => {
    const d3Container = useRef(null);
    const theme = useTheme();
    const { groupKeys } = useContext(GroupsContext);

    useEffect((didUpdate) => {
        const chartColors = ['#1A9EA3', '#BFD855', '#7BA9F2', theme.palette.error.main, theme.palette.warning.main];
        const colors = D3scaleOrdinal().range(chartColors).domain(groupKeys);

        const progChartColors = ['#24A5E9', '#0A3046'];
        const progColors = D3scaleOrdinal().range(progChartColors).domain(groupKeys);

        const handleOnMouseover = g => {
            mouseover && mouseover(g);
        };

        if (d3Container.current) {
            const node = d3Container.current;
            const g = D3select(node)
                .data([data])
                .join('g')
                .call(D3ProgdDonut()
                    .progdata(progdata)
                    .theme(theme)
                    .colors(colors)
                    .progcolors(progColors)
                    .date(filter)
                    .size(size)
                    .on('mouseover', handleOnMouseover)
                    .on('click', onclick));
            g.exit().remove();
        }
    }, [theme, mouseover, onclick, size, data, progdata, filter]);

    return (
        <div
            className={className}
            name="donut_chart"
            ref={d3Container}
            style={ { width: size, height: size }}>
        </div>
    );
};

DoubleDonutChart.propTypes = {
    size: PropTypes.number.isRequired,
    shift: PropTypes.number,
    data: PropTypes.array.isRequired,
    progdata: PropTypes.array.isRequired,
    filter: PropTypes.object,
    className: PropTypes.string,
    mouseover: PropTypes.func,
    onclick: PropTypes.func,
};

export default DoubleDonutChart;
